<template>
  <div>
    <!-- Read only address -->
    <div class="px-6 py-2 mb-1 grey lighten-4 text--secondary rounded-xl module" v-text="address" />

    <!-- Subtitle -->
    <div class="caption grey--text px-3">
      Address
    </div>
  </div>
</template>

<script>
  import store from '@/store'

  export default {
    name: 'ReadOnlySenderNode',
    props: {
      nodeId: {
        type: String,
        default: ''
      },
    },
    computed: {
      address () {
        return store.getters.getNodeDataByNodeId(this.nodeId)?.address || 'Empty'
      }
    },
  }
</script>

<style scoped>
  .module {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
